module.exports = __webpack_public_path__ + "static/assets/764db4b359e1df97f267c452ca3bbcb3.svg";